import { usePartStateContext } from "@/pages/configurations/partState/context/PartsContext";
import { useVendorsContext } from "@/pages/configurations/vendors/context/VendorsContext";
import { Vendor } from "@/pages/configurations/vendors/models/Vendor";
import { Button, Grid } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import { ColDef } from "ag-grid-community";
import { find } from "lodash-es";
import { useMemo } from "react";
import { usePartsContext } from "../../../context/PartsContext";

type Props = {
	/*  gridRef:Function, */
	setModalEditPart: Function;
	setModalComponentType: Function;
	setModalDeletePart: Function;
	setPartIdForEdit: Function;
	setPartIdForDelete: Function;
};

export const useTableData = ({
	setPartIdForEdit,
	setModalEditPart,
	setPartIdForDelete,
	setModalDeletePart,
	setModalComponentType,
}: Props) => {
	const {
		state: { parts },
	} = usePartsContext();
	const {
		state: { partState },
	} = usePartStateContext();
	const {
		state: { vendors },
	} = useVendorsContext();

	const columns: ColDef[] = [
		{
			field: "partId",
			headerName: "#",
			// width: 100,
			flex: 1,
			filter: "agSetColumnFilter",
		},
		{
			field: "partName",
			headerName: "Name",
			flex: 3,
		},
		{
			field: "componentTypes",
			headerName: "Component Types",

			cellRenderer: (params: any) => {
				return (
					<Grid
						container
						justifyContent="center"
						alignItems="center"
						spacing={1}
						style={{ padding: "0" }}
					>
						<Grid
							item
							md={6}
							xs={6}
							style={{ padding: "0", marginLeft: -65, marginTop: 1 }}
						>
							<Button
								variant="outlined"
								color="primary"
								size="small"
								onClick={() => {
									(async () => {
										setPartIdForEdit(params.data.partId);
										setModalComponentType(true);
									})();
								}}
							>
								Components
							</Button>
						</Grid>
					</Grid>
				);
			},
			sortable: false,
			flex: 2,
		},
		{
			field: "isActive",
			headerName: "Status",
			flex: 1,
		},
		{
			field: "description",
			headerName: "Description",
			flex: 3,
		},
		{
			field: "sku",
			headerName: "SKU",
			flex: 1,
		},
		{
			field: "unit",
			headerName: "Unit",
			flex: 1,
		},
		{
			field: "vendorId",
			headerName: "Vendor",
			flex: 2,
		},
		{
			field: "Actions",
			cellRenderer: (params: any) => {
				return (
					<Grid
						container
						justifyContent="center"
						alignItems="center"
						spacing={1}
						style={{ padding: "0" }}
					>
						<Grid item md={6} xs={6} style={{ padding: "0", marginLeft: -25 }}>
							<Button
								fullWidth
								onClick={() => {
									(async () => {
										setPartIdForEdit(params.data.partId);
										setModalEditPart(true);
									})();
								}}
							>
								<EditIcon style={{ width: 16, height: 16 }} color="primary" />
							</Button>
						</Grid>
						<Grid item md={6} xs={6} style={{ padding: "0" }}>
							<Button
								fullWidth
								onClick={() => {
									(async () => {
										setPartIdForDelete(params.data.partId);
										setModalDeletePart(true);
									})();
								}}
							>
								<DeleteIcon
									style={{ width: 16, height: 16 }}
									color="secondary"
								/>
							</Button>
						</Grid>
					</Grid>
				);
			},
			headerName: " ",
			sortable: false,
			flex: 1,
		},
	];

	const defaultColDef = useMemo(
		() => ({
			resizable: true,
			sortable: true,
			filter: true,
			suppressMenu: true,
		}),
		[],
	);

	const rows = parts.map(
		({
			partId,
			partName,
			description,
			sku,
			unit,
			partStateId,
			vendorId,
			refurbishVendor,
			removalDate,
			sendToVendorDate,
			estimatedArrival,
			actualArrival,
			isActive,
		}) => {
			const vendor: Vendor | undefined = find(vendors, ["vendorId", vendorId]);

			return {
				partId,
				partName,
				description,
				sku,
				unit,
				partStateId,
				vendorId: vendor?.vendorName,
				refurbishVendor,
				removalDate,
				sendToVendorDate,
				estimatedArrival,
				actualArrival,
				isActive: isActive ? "Active" : "Inactive",
				id: partId,
			};
		},
	);
	return { rows, columns, defaultColDef };
};
